/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keep_Window_Open_Until_Upload_CompleteInputs */



/**
* | output |
* | --- |
* | "Please leave this window open until your upload completes." |
*
* @param {Keep_Window_Open_Until_Upload_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const keep_window_open_until_upload_complete = /** @type {((inputs?: Keep_Window_Open_Until_Upload_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keep_Window_Open_Until_Upload_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez laisser cette fenêtre ouverte jusqu’à la fin du téléversement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte lassen Sie dieses Fenster so lange geöffnet, bis Ihr Upload abgeschlossen ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lascia questa finestra aperta fino al completamento del caricamento.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, оставьте это окно открытым до завершения загрузки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deje esta ventana abierta hasta que se complete la carga.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请保持此窗口打开，直到上传完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップロードが完了するまでこのウィンドウを開いたままにしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया अपलोड पूरा होने तक इस विंडो को खुला रखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, mantenha esta janela aberta até que o seu upload seja concluído.")
	return /** @type {LocalizedString} */ ("Please leave this window open until your upload completes.")
});